var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.8601C20.7249 8.88039 19.8065 7.04601 18.3862 5.63958C16.966 4.23314 15.1227 3.33268 13.1404 3.07689C11.158 2.8211 9.14658 3.22419 7.41585 4.22404C5.68513 5.2239 4.33116 6.76507 3.5625 8.61014M3 4.11014V8.61014H7.5",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.1094C3.27513 15.0891 4.19355 16.9235 5.61378 18.3299C7.03402 19.7364 8.87727 20.6368 10.8596 20.8926C12.842 21.1484 14.8534 20.7453 16.5841 19.7455C18.3149 18.7456 19.6688 17.2044 20.4375 15.3594M21 19.8594V15.3594H16.5",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnRefresh);
export default __webpack_public_path__ + "static/media/icn_refresh.265a9c071830233c1b09193759d76fcc.svg";
export { ForwardRef as ReactComponent };